const routes = [
    {
        path: "/document/request/form",
        component: () => import("../pages/student/DocumentRequestForm"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        }
    },
    {
        path: "/document/requests",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'documentrequest_index',
        }
    }
]

export default routes;
